import React from "react";
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';
import RouterSwitch from "./RouterSwitch";
import Languages from "../../../Languages/Languages";
import Settings from '../Settings/Settings'
import Theme from '../../../Themes/ThemeBcmag'
import { ThemeProvider } from '@mui/material/styles';
class RouterComponent extends React.Component {
    constructor(props) {
        super(props);
        let lang = Languages[Settings.defaultLanguage]

        this.state = {
            language: lang,
            products: [],
            errors: [],
            createAccountYears: {
                items: []
            },
            counties: {
                items: []
            },
            addresses: {
                items: []
            },
            firms: {
                items: []
            },
            loadingShoppingCartItems: false,
            shoppingCartItems: [],
            showAddedToCartDialog: false,
            deliveryMethods:[],
            orders: [],
            loadingFirms: true,
            userOrders: [],
            userOrderItems: [],
            compatibleProducts: [],
            openDeleteProductsDialog: false,
            openDeleteProductsProductDialog: false
        }
    }

    componentDidMount() {
    }
    clearErrorMessage(index) {
        let errorsMessages = this.state.errors
        errorsMessages.splice(index, 1);
        this.setManagerState({errors: errorsMessages})
    }
    setManagerState(stateObject, callback = () => {}) {
        if(stateObject) {
            this.setState(stateObject,() => {
                this.refresh(callback)
            })
        }
    }

    getManagerState() {
        return this.state
    }
    render() {

          return <ThemeProvider theme={Theme}>
                    <Router>
                        <RouterSwitch
                        getManagerState={() => { return this.getManagerState()}}
                        websocketSend={(data, type)=>{this.websocketSend(data, type)}}
                        setManagerState={(stateObject, callback) => {this.setManagerState(stateObject, callback)}}
                        setScrollPosition={(scrollPos) => {this.setScrollPosition(scrollPos)}}
                        clearErrorMessage={(index) => {this.clearErrorMessage(index)}}
                        />
                    </Router>
                </ThemeProvider>
    }
    refresh(callback = () => {}) {
        this.forceUpdate()
        callback()
    }
}

export default RouterComponent